module.exports = __webpack_public_path__ + "static/media/Gun_Bay_02.26db5f66.jpg";